var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full w-full antialiased",class:_vm.theme},[_c('router-view'),_vm._v(" "),_c('snackbar-container')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }